<app-lfsa-card *ngIf="!loading" [innTemplate]="enviarTemplate" [titulo]="'Carga de Extractos Bancarios'">
</app-lfsa-card>
<ng-template #enviarTemplate>
  <form [formGroup]="formulario" class="form-group" novalidate>

    <div class="row col 12">
      <div class="form-group col-md-4">
        <app-lfsa-combo-box (change)="BancoEmpresa($event.target)" [claseLabel]="'letrasDanger'" [comboBox]="cmbEmpresa"
                            [control]="this.formulario.get('idEmpresa') | formControl" [idOpcion]="'idEmpresa'"
                            [id]="'idEmpresa'"
                            [label]="'Sociedad*'" [opcion]="'dscaEmpresa'" formControlName="idEmpresa">
        </app-lfsa-combo-box>
      </div>
      <div class="form-group col-md-4">
        <app-lfsa-combo-box (change)="cuentaBanco($event.target)" [claseLabel]="'letrasDanger'" [comboBox]="cmbBanco"
                            [control]="this.formulario.get('idBanco') | formControl" [idOpcion]="'idBanco'"
                            [id]="'idBanco'"
                            [label]="'Bancos*'" [opcion]="'dscaBanco'"
                            formControlName="idBanco"></app-lfsa-combo-box>
      </div>

      <div class="form-group col-md-4">
        <app-lfsa-input [claseLabel]="'letrasDanger'" [control]="this.formulario.get('cuenta') | formControl"
                        [id]="'cuenta'"
                        [isReadOnly]="bloquearCampo" [label]="'N° Cuenta*'" [type]="'number'"
                        formControlName="cuenta">
        </app-lfsa-input>
      </div>

    </div>
    <div class="row col 12">
      <div class="form-group col-md-4">
        <app-lfsa-input [claseLabel]="'letrasDanger'" [control]="this.formulario.get('fechaExtracto') | formControl"
                        [id]="'fechaExtracto'" [label]="'Fecha Extracto*'" [type]="'date'"
                        formControlName="fechaExtracto">
        </app-lfsa-input>
      </div>
    </div>
    <div class="col-12">
      <form (ngSubmit)="onSubmit()" [formGroup]="formulario">
        <div class="row">
          <div [hidden]="ocultarExtractoBancario" class="col-6">
            <div class="form-group animated fadeInRight">
              <label class="letrasDanger" for="excelInputExtractos">Cargar Extractos .csv*</label>
              <input #fileInput (change)="onFileSelect($event)" accept=".csv"
                     class="form-control-file" id="excelInputExtractos" type="file"/>
            </div>


          </div>
        </div>
        <br>
        <div *ngIf="formulario.invalid" class="row">
          <div class="form-group col-12">
            <div class="alert alert-danger animated fadeInRight" role="alert">
              <h5><b> El botón se activará cuando complete toda la información requerida que está marcada con (*) </b>
              </h5>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4">
            <button [disabled]="formulario.invalid"
                    class="{{DAT_BTNCSS.primary}}">{{ DATA_BTNS.procesar }}
            </button>
          </div>
        </div>
      </form>
    </div>
  </form>
</ng-template>
<div *ngIf="loading" class="containerLoader">
  <div class="item-1"></div>
  <div class="item-2"></div>
  <div class="item-3"></div>
  <div class="item-4"></div>
  <div class="item-5"></div>
</div>

<app-lfsa-card *ngIf="reporte && reporte.listConciBancaDetalla.length > 0" [innTemplate]="resultTemplate" [titulo]="'Resultados Carga'">
</app-lfsa-card>
<ng-template #resultTemplate>
  <div class="reporte-container">
    <!-- Mostrar la cabecera del reporte -->
    <div class="reporte-cabecera">
      <div class="row">
        <div class="col-md-2">
          <p><strong>Empresa:</strong> {{ reporte?.conciBancaCabecera?.idEmpresa }}</p>
        </div>
        <div class="col-md-2">
          <p><strong>Banco:</strong> {{ reporte?.conciBancaCabecera?.idBanco }}</p>
        </div>
        <div class="col-md-2">
          <p><strong>Clave Banco:</strong> {{ reporte?.conciBancaCabecera?.claveBanco }}</p>
        </div>
        <div class="col-md-2">
          <p><strong>Cuenta Bancaria:</strong> {{ reporte?.conciBancaCabecera?.cuentaBancaria }}</p>
        </div>
        <div class="col-md-2">
          <p><strong>Fecha Extracto:</strong> {{ reporte?.conciBancaCabecera?.fechaExtracto }}</p>
        </div>
      </div>
      <div class="row">
        <div class="col-md-2">
          <p><strong>Saldo Inicial:</strong> {{ reporte?.conciBancaCabecera?.saldoInicial | currency }}</p>
        </div>
        <div class="col-md-2">
          <p><strong>Débito Total:</strong> {{ reporte?.conciBancaCabecera?.debitoTotal | currency }}</p>
        </div>
        <div class="col-md-2">
          <p><strong>Crédito Total:</strong> {{ reporte?.conciBancaCabecera?.creditoTotal | currency }}</p>
        </div>
        <div class="col-md-2">
          <p><strong>Saldo Final:</strong> {{ reporte?.conciBancaCabecera?.saldoFinal | currency }}</p>
        </div>
        <div class="col-md-2">
          <p><strong>Número de Registros:</strong> {{ reporte?.conciBancaCabecera?.numeroRegistros }}</p>
        </div>
      </div>
    </div>

    <!-- Mostrar el detalle del reporte -->
    <h3>Detalle del Extracto</h3>
    <div class="d-flex flex-row-reverse">
      <!--<button (click)="exportAsExcel()" class="btn btn-success">Exportar</button>-->
      <button (click)="exportAsExcel(reporte?.listConciBancaDetalla)"  class="btn btn-success" type="button" style="text-align: right;"><svg class="bi bi-filetype-xls" xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="currentColor" viewBox="0 0 16 16">
        <path fill-rule="evenodd" d="M14 4.5V14a2 2 0 0 1-2 2h-1v-1h1a1 1 0 0 0 1-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5L14 4.5ZM6.472 15.29a1.176 1.176 0 0 1-.111-.449h.765a.578.578 0 0 0 .254.384c.07.049.154.087.25.114.095.028.202.041.319.041.164 0 .302-.023.413-.07a.559.559 0 0 0 .255-.193.507.507 0 0 0 .085-.29.387.387 0 0 0-.153-.326c-.101-.08-.255-.144-.462-.193l-.619-.143a1.72 1.72 0 0 1-.539-.214 1.001 1.001 0 0 1-.351-.367 1.068 1.068 0 0 1-.123-.524c0-.244.063-.457.19-.639.127-.181.303-.322.527-.422.225-.1.484-.149.777-.149.305 0 .564.05.78.152.216.102.383.239.5.41.12.17.186.359.2.566h-.75a.56.56 0 0 0-.12-.258.625.625 0 0 0-.247-.181.923.923 0 0 0-.369-.068c-.217 0-.388.05-.513.152a.472.472 0 0 0-.184.384c0 .121.048.22.143.3a.97.97 0 0 0 .405.175l.62.143c.217.05.406.12.566.211a1 1 0 0 1 .375.358c.09.148.135.335.135.56 0 .247-.063.466-.188.656a1.216 1.216 0 0 1-.539.439c-.234.105-.52.158-.858.158-.254 0-.476-.03-.665-.09a1.404 1.404 0 0 1-.478-.252 1.13 1.13 0 0 1-.29-.375Zm-2.945-3.358h-.893L1.81 13.37h-.036l-.832-1.438h-.93l1.227 1.983L0 15.931h.861l.853-1.415h.035l.85 1.415h.908L2.253 13.94l1.274-2.007Zm2.727 3.325H4.557v-3.325h-.79v4h2.487v-.675Z"></path>
      </svg>Descarga .XLS</button>
    </div>
    <table class="reporte-detalle">
      <thead>
      <tr>
        <th>Referencia</th>
        <th>Fecha Extracto</th>
        <th>Clave Operativa</th>
        <th>Monto</th>
<!--        <th>Saldo</th>-->
        <th>Fecha Contable</th>
        <th>Observación</th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let detalle of reporte?.listConciBancaDetalla">
        <td>{{ detalle.numeroReferencia }}</td>
        <td>{{ detalle.fechaExtracto | date: 'yyyy-MM-dd' }}</td>
        <td>{{ detalle.claveOperativa }}</td>
        <td>{{ detalle.monto | currency }}</td>
<!--        <td>{{ detalle.saldo | currency }}</td>-->
        <td>{{ detalle.fechaContable | date: 'yyyy-MM-dd' }}</td>
        <td>{{ detalle.observacion }}</td>
      </tr>
      </tbody>
    </table>
  </div>

</ng-template>
